import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ImageSphereLoadingMessageOuter = styled.div`
  ${flexCentreAlignCss}
  height: 100%;
  width: 100%;
`;

export const ImageSphereLoadingMessage = styled.div`
  max-width: ${rem(400)};
  width: 100%;
`;
